/**
 * Generated file
 * Do not edit directly
 */
import React from 'react';
import { Icon, IconProps } from '@chakra-ui/react';

export const ErrorOutlineIcon = ({ css, ...props }: IconProps) => {
  return (
    <Icon
      height="24px"
      width="24px"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.5 12C20.5 16.6944 16.6944 20.5 12 20.5C9.96737 20.5 8.10137 19.7865 6.63879 18.5964L18.5964 6.63879C19.7865 8.10137 20.5 9.96737 20.5 12ZM5.56276 17.5511L17.5511 5.56276C16.0618 4.27734 14.1217 3.5 12 3.5C7.30558 3.5 3.5 7.30558 3.5 12C3.5 14.1217 4.27734 16.0618 5.56276 17.5511ZM22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
        fill="currentColor"
      ></path>
    </Icon>
  );
};
